import React from "react";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import DefaultDetails from "./DefaultDetails";
import GroundLogoSettings from "./GroundLogoSetting";
import ThemesDetails from "../addComponentDialog/ThemesDetails";
import EventsDetails from "../addComponentDialog/EventsDetails";
import WallsDetails from "../addComponentDialog/WallsDetails";

const PREFIX = "TileDialogContent";

const classes = {
  root: `${PREFIX}-root`,
};

const TileDialogContentContainer = styled("div")(({ theme }) => {
  return {
    [`& .${classes.root}`]: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      justifyContent: "center",
      "& > div": {
        width: "100%",
      },
    },
  };
});

const TileDialogContent = () => {
  const layout = useSelector((state) => state.configurator.layout);

  const displays = {
    normal: <DefaultDetails />,
    event: <EventsDetails />,
    theme: <ThemesDetails />,
    walls: <WallsDetails />,
  };

  return (
    <TileDialogContentContainer>
      <div className={classes.root}>
        {layout === "normal" && <GroundLogoSettings />}
        {displays[layout]}
      </div>
    </TileDialogContentContainer>
  );
};

export default TileDialogContent;
